export default "__VITE_ASSET__D4Tc$aYF__"